import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=f5dfa162&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=ts"
export * from "./Carousel.vue?vue&type=script&lang=ts"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=f5dfa162&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dfa162",
  null
  
)

export default component.exports